import {Wrench} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {Alert, AlertDescription, AlertTitle} from '@/components/ui/alert';
import {useMaintenanceMode} from '@/hooks/useMaintenanceMode';

function MaintenanceBanner() {
  const {t} = useTranslation();
  const isMaintenanceMode = useMaintenanceMode();

  if (!isMaintenanceMode) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-50 flex justify-center max-sm:bottom-24">
      <Alert variant="warning" className="pointer-events-auto max-w-[420px]">
        <Wrench aria-hidden="true" />
        <AlertTitle>{t('Application Update')}</AlertTitle>
        <AlertDescription>
          {t(
            'The application is being updated and may reload. Save your work now. QR code login may not work until the update is complete.'
          )}
        </AlertDescription>
      </Alert>
    </div>
  );
}

export default MaintenanceBanner;
